import * as React from "react";
import {motion} from "framer-motion"

function SvgComponent(props) {
  return (
    <svg width={"100%"}  viewBox="0 0 682.29 584.53" {...props}>
      <defs>
        <clipPath id="prefix__clip-path">
          <path
            d="M475.41 195.05l34.16 19.75a1.83 1.83 0 002.75-1.59V183a1.81 1.81 0 00-.91-1.59l-34.16-19.76a1.84 1.84 0 00-2.75 1.59v30.18a1.83 1.83 0 00.91 1.63z"
            fill="none"
          />
        </clipPath>
      </defs>
      <g
        style={{
          isolation: "isolate",
        }}
      >
        <g id="prefix__Layer_2" data-name="Layer 2">
          <g id="prefix__Layer_1-2" data-name="Layer 1">
            <path
              id="prefix__background"
              d="M30.37 248.84C11.71 260.12-2.77 281.22.45 302.78 4.93 332.83 40 351 44.9 381c4.71 29-20.55 54.34-24.56 83.41-4.4 31.93 18.86 62.87 48.18 76.25s63.12 12.5 95 7.87 63.47-12.75 95.7-13c35.18-.3 69.68 8.76 103.91 16.9s69.4 15.44 104.38 11.57 70.24-20.62 88.13-50.91c21.48-36.35 14.92-85.3 40.12-119.17 14.08-18.91 36.06-30.17 52.88-46.69 25.94-25.49 38.31-64.05 32-99.87s-31-67.89-64.06-83c-31.6-14.49-70.43-14.8-96.13-38.22-16.24-14.8-24.23-36.37-36.56-54.56a131.16 131.16 0 00-199.24-21.2C264.32 69.84 247 97.6 219 100.23c-20.2 1.9-38.83-10.51-58.83-13.88-32.78-5.52-67.86 17.32-76.06 49.54-3.66 14.37-.07 29.16 4.35 43.22 16.54 52.65-42.14 60.09-58.09 69.73z"
              fill="#f2f2f2"
            />
            <g id="prefix__keyboard">
              <path
                d="M274.09 283.29a11.37 11.37 0 0110.3 0l193.19 112.47c2.83 1.65 2.82 4.32 0 6l-86 49.87a11.37 11.37 0 01-10.3 0L188 339.13c-2.83-1.65-2.81-4.32 0-6z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#333"
                opacity={0.5}
              />
              <path
                d="M478.44 391.8l-5.77-3.68v1.26L282.08 278.62a11.07 11.07 0 00-10 0l-81.32 47.12v-.68l-5.76 3.27v2.5a3.5 3.5 0 002 2.85L381.31 446.6a11.07 11.07 0 0010 0l85-49.24c2.1-1.23 1.94-2.2 2-3.47.07-.57.13-2.09.13-2.09z"
                fill="#fff"
              />
              <path
                d="M272 276.13a11.07 11.07 0 0110 0L476.38 389c2.76 1.6 2.74 4.2 0 5.81l-85 49.24a11 11 0 01-10 0L187 331.18c-2.76-1.6-2.74-4.21 0-5.82z"
                fill="#c41b1b"
              />
              <path
                d="M271.84 283.72a2.85 2.85 0 012.59 0l8.9 5.17a.79.79 0 010 1.5l-6.86 4a2.87 2.87 0 01-2.6 0l-8.9-5.17c-.72-.42-.71-1.09 0-1.51zm5.62 11.22c-.72.42-.73 1.09 0 1.5l8.91 5.18a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.85 2.85 0 00-2.59 0zm12.74 7.4c-.72.42-.73 1.09 0 1.51l8.9 5.17a2.86 2.86 0 002.61 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.88 2.88 0 00-2.59 0zm12.88 7.48c-.73.42-.74 1.09 0 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4c.71-.42.73-1.09 0-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.73 7.4a.8.8 0 000 1.51l8.9 5.17a2.86 2.86 0 002.61 0l6.87-4a.79.79 0 000-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.76 7.42c-.73.41-.74 1.09 0 1.5l8.9 5.18a2.87 2.87 0 002.6 0l6.86-4c.71-.41.73-1.09 0-1.5l-8.9-5.17a2.82 2.82 0 00-2.59 0zM341.3 332a.8.8 0 000 1.51l8.9 5.17a2.9 2.9 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.9 2.9 0 00-2.6 0zm12.76 7.41c-.73.42-.73 1.09 0 1.51l8.9 5.17a2.89 2.89 0 002.61 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.88 2.88 0 00-2.59 0zm12.74 7.41a.79.79 0 000 1.5l8.9 5.17a2.84 2.84 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.77 7.42a.8.8 0 000 1.51l8.9 5.17a2.9 2.9 0 002.6 0l6.86-4a.8.8 0 000-1.5l-8.93-5.1a2.88 2.88 0 00-2.59 0zm12.75 7.41c-.72.41-.74 1.08 0 1.5l8.9 5.17a2.84 2.84 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.75 7.41c-.72.41-.73 1.09 0 1.5l8.91 5.18a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.91-5.17a2.85 2.85 0 00-2.59 0zm12.74 7.4c-.72.42-.73 1.09 0 1.5l8.9 5.18a2.92 2.92 0 002.61 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.88 2.88 0 00-2.59 0zm12.75 7.41c-.72.42-.73 1.09 0 1.51l8.91 5.17a2.84 2.84 0 002.6 0l6.86-4a.79.79 0 000-1.5L440 380a2.85 2.85 0 00-2.59 0zm12.74 7.4c-.72.42-.73 1.1 0 1.51l8.9 5.18a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.87 2.87 0 00-2.6 0zm-188.84-97.52c-.72.42-.73 1.09 0 1.51l30 17.44a2.82 2.82 0 002.59 0l6.86-4c.72-.42.73-1.08 0-1.5l-30-17.45a2.88 2.88 0 00-2.59 0zm33.93 19.72a.8.8 0 000 1.51l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.42.72-1.09 0-1.5l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.74 7.41a.79.79 0 000 1.5l8.9 5.17a2.84 2.84 0 002.6 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.82 2.82 0 00-2.59 0zm12.76 7.41c-.72.42-.73 1.09 0 1.5l8.9 5.18a2.88 2.88 0 002.59 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.82 2.82 0 00-2.59 0zm12.73 7.4a.79.79 0 000 1.5l8.91 5.18a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.91-5.18a2.88 2.88 0 00-2.59 0zm12.76 7.42a.79.79 0 000 1.5l8.9 5.17a2.82 2.82 0 002.59 0l6.86-4c.72-.42.73-1.09 0-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.73 7.4a.79.79 0 000 1.5l8.91 5.18a2.88 2.88 0 002.59 0l6.86-4a.79.79 0 000-1.5l-8.91-5.17a2.87 2.87 0 00-2.6 0zm12.79 7.43c-.73.41-.72 1.08 0 1.5l8.9 5.17a2.84 2.84 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.74 7.4c-.72.42-.72 1.09 0 1.5l8.9 5.17a2.82 2.82 0 002.59 0l6.87-4c.72-.41.72-1.08 0-1.5l-8.9-5.17a2.82 2.82 0 00-2.59 0zm12.75 7.41a.79.79 0 000 1.5l8.9 5.18a2.88 2.88 0 002.59 0l6.86-4c.72-.42.72-1.09 0-1.5l-8.9-5.18a2.87 2.87 0 00-2.6 0zm12.74 7.4a.8.8 0 000 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4c.73-.42.72-1.09 0-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.75 7.42c-.72.41-.72 1.08 0 1.5l8.9 5.17a2.82 2.82 0 002.59 0l6.86-4c.72-.42.72-1.09 0-1.5l-8.9-5.17a2.82 2.82 0 00-2.59 0zm12.74 7.4a.79.79 0 000 1.5l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4c.73-.41.72-1.08 0-1.5l-8.9-5.17a2.85 2.85 0 00-2.59 0zm-184.76-95.1c-.72.42-.72 1.09 0 1.5l9.62 5.59a2.82 2.82 0 002.59 0l6.86-4c.72-.42.73-1.08 0-1.5l-9.62-5.59a2.82 2.82 0 00-2.59 0zm13.26 7.71a.79.79 0 000 1.5l9.62 5.59a2.82 2.82 0 002.59 0l6.86-4a.79.79 0 000-1.5l-9.62-5.59a2.87 2.87 0 00-2.6 0zM222.84 312c-.72.41-.72 1.08 0 1.5l6.74 3.91a2.82 2.82 0 002.59 0l17.31-10c.72-.42.73-1.09 0-1.51l-6.72-3.9a2.84 2.84 0 00-2.6 0zm21 .12a.79.79 0 000 1.5l9.62 5.59a2.84 2.84 0 002.6 0l6.86-4a.8.8 0 000-1.51l-9.62-5.59a2.87 2.87 0 00-2.6 0zm40.13 11c-.71.41-.73 1.09 0 1.5l8.9 5.17a2.82 2.82 0 002.59 0l6.86-4c.72-.41.74-1.09 0-1.5l-8.9-5.18a2.87 2.87 0 00-2.6 0zm-23.39-1.42a.8.8 0 000 1.52l17.61 10.23a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-7.42-4.31 9.21-5.32a.79.79 0 000-1.5l-8.9-5.17a2.86 2.86 0 00-2.61 0l-10.51 6.06-2.42 1.5zm36.12 8.82a.8.8 0 000 1.51l8.91 5.17a2.88 2.88 0 002.59 0l6.86-4a.8.8 0 000-1.51l-8.91-5.17a2.86 2.86 0 00-2.61 0zm12.81 7.48c-.71.42-.72 1.09 0 1.5l8.9 5.18a2.9 2.9 0 002.6 0l6.86-4a.8.8 0 000-1.51L319 334a2.9 2.9 0 00-2.6 0zm12.73 7.41a.79.79 0 000 1.5l8.91 5.17a2.82 2.82 0 002.59 0l6.86-4c.72-.41.73-1.09 0-1.5l-8.91-5.18a2.92 2.92 0 00-2.61 0zm12.76 7.36a.79.79 0 000 1.5l8.91 5.18a2.88 2.88 0 002.59 0l6.86-4c.72-.41.73-1.09 0-1.5l-8.91-5.18a2.87 2.87 0 00-2.6 0zm12.74 7.4c-.71.42-.72 1.09 0 1.5l8.9 5.18a2.88 2.88 0 002.59 0l6.87-4c.72-.42.73-1.09 0-1.51l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.78 7.43a.79.79 0 000 1.5l8.9 5.18a2.88 2.88 0 002.59 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.86 2.86 0 00-2.61 0zm12.74 7.4c-.71.42-.72 1.09 0 1.5l8.9 5.18a2.9 2.9 0 002.6 0l6.86-4c.73-.42.73-1.09 0-1.51l-8.9-5.17a2.9 2.9 0 00-2.6 0zm12.74 7.42a.79.79 0 000 1.5l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.42.73-1.09 0-1.51l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.74 7.4a.79.79 0 000 1.5l8.9 5.18a2.88 2.88 0 002.59 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.86 2.86 0 00-2.61 0zm12.94 7.51c-.72.42-.73 1.09 0 1.5l19.46 11.32a2.88 2.88 0 002.59 0l6.87-4a.8.8 0 000-1.51l-19.46-11.31a2.87 2.87 0 00-2.6 0zm-129.6-63.14c-.73.42-.73 1.1 0 1.51l8.9 5.17a2.86 2.86 0 002.61 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.88 2.88 0 00-2.59 0zm12.75 7.42c-.72.41-.74 1.08 0 1.5l8.9 5.17a2.84 2.84 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.74 7.4a.8.8 0 000 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4a.8.8 0 000-1.5l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.75 7.41c-.72.41-.73 1.09 0 1.5l8.9 5.18a2.92 2.92 0 002.61 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.88 2.88 0 00-2.59 0zm12.74 7.4c-.72.42-.73 1.09 0 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.78 7.43a.8.8 0 000 1.51l8.9 5.17a2.9 2.9 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.9 2.9 0 00-2.6 0zm12.74 7.4c-.72.42-.73 1.09 0 1.51l8.91 5.17a2.87 2.87 0 002.6 0l6.86-4c.71-.42.72-1.09 0-1.5l-8.95-5.14a2.88 2.88 0 00-2.59 0zm12.75 7.41c-.72.42-.73 1.1 0 1.51l8.9 5.18a2.87 2.87 0 002.6 0l6.86-4c.71-.41.73-1.09 0-1.5l-8.9-5.18a2.9 2.9 0 00-2.6 0zm12.74 7.41a.79.79 0 000 1.5l8.91 5.18a2.9 2.9 0 002.6 0l6.87-4a.79.79 0 000-1.5l-8.91-5.17a2.82 2.82 0 00-2.59 0zm12.76 7.41c-.73.42-.74 1.09 0 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.85 2.85 0 00-2.59 0zm12.73 7.4a.8.8 0 000 1.51l11.07 6.43a2.85 2.85 0 002.59 0l6.87-4a.79.79 0 000-1.5l-11.09-6.4a2.9 2.9 0 00-2.6 0zm-176.12-90.12c-.72.42-.73 1.09 0 1.5l9.62 5.59a2.84 2.84 0 002.6 0l6.86-4a.8.8 0 000-1.51l-9.62-5.59a2.88 2.88 0 00-2.59 0zm13.84 8a.8.8 0 000 1.51l11.72 6.8a2.88 2.88 0 002.59 0l6.87-4a.8.8 0 000-1.51l-11.74-6.82a2.86 2.86 0 00-2.61 0zm15.72 9.12a.79.79 0 000 1.5l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.73-.42.74-1.09 0-1.51l-8.9-5.17a2.84 2.84 0 00-2.6 0zm12.74 7.4a.79.79 0 000 1.5l8.9 5.18a2.88 2.88 0 002.59 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.86 2.86 0 00-2.61 0zm12.75 7.41a.79.79 0 000 1.5l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4c.73-.42.73-1.1 0-1.51l-8.9-5.18a2.87 2.87 0 00-2.6 0zm12.74 7.4a.8.8 0 000 1.51l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.42.73-1.09 0-1.51l-8.9-5.17a2.86 2.86 0 00-2.61 0zM314 364.9a.79.79 0 000 1.5l8.91 5.18a2.88 2.88 0 002.59 0l6.86-4c.73-.42.73-1.1 0-1.51l-8.91-5.17a2.84 2.84 0 00-2.6 0zm12.74 7.41a.79.79 0 000 1.5l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.42.73-1.09 0-1.51l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.78 7.42a.8.8 0 000 1.51l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.42.74-1.09 0-1.51l-8.9-5.17a2.86 2.86 0 00-2.61 0zm12.74 7.41a.8.8 0 000 1.5l8.91 5.17a2.87 2.87 0 002.6 0l6.86-4a.81.81 0 000-1.52l-8.91-5.17a2.87 2.87 0 00-2.6 0zm12.74 7.41a.79.79 0 000 1.5l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.41.74-1.09 0-1.5l-8.9-5.18a2.87 2.87 0 00-2.6 0zm12.73 7.4a.8.8 0 000 1.51l8.9 5.17a2.88 2.88 0 002.59 0l6.87-4a.8.8 0 000-1.51L387.2 398a2.86 2.86 0 00-2.61 0zm12.94 7.52a.79.79 0 000 1.5l19.47 11.31a2.88 2.88 0 002.59 0l6.86-4a.8.8 0 000-1.51l-19.46-11.27a2.87 2.87 0 00-2.6 0zm-188.92-85.28c-.72.41-.74 1.09 0 1.5l6.74 3.92a2.84 2.84 0 002.6 0l17.39-10c.72-.41.74-1.09 0-1.5l-6.74-3.92a2.84 2.84 0 00-2.6 0zm20.85-.08a.79.79 0 000 1.5l10.16 5.9a2.87 2.87 0 002.6 0l6.86-4a.8.8 0 000-1.51l-10.16-5.9a2.84 2.84 0 00-2.6 0zm14.06 8.17a.79.79 0 000 1.5l5 2.92a2.87 2.87 0 002.6 0l6.86-4a.8.8 0 000-1.51l-5-2.93a2.92 2.92 0 00-2.61 0zm9.31 5.41a.79.79 0 000 1.5l5.27 3.06a2.87 2.87 0 002.6 0l6.86-4a.8.8 0 000-1.51l-5.27-3.06a2.84 2.84 0 00-2.6 0zm9.29 5.4a.8.8 0 000 1.5l14.59 8.48a2.9 2.9 0 002.6 0l6.87-4a.8.8 0 000-1.51l-14.59-8.48a2.87 2.87 0 00-2.6 0zm18.45 10.72a.79.79 0 000 1.5l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.42.74-1.09 0-1.51l-8.9-5.17a2.84 2.84 0 00-2.6 0zm12.73 7.4a.79.79 0 000 1.5l8.9 5.18a2.88 2.88 0 002.59 0l6.87-4a.79.79 0 000-1.5l-8.9-5.17a2.86 2.86 0 00-2.61 0zm12.76 7.41a.79.79 0 000 1.5l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4c.72-.42.73-1.1 0-1.51l-8.9-5.18a2.87 2.87 0 00-2.6 0zm12.74 7.38a.79.79 0 000 1.5l8.9 5.17a2.85 2.85 0 002.59 0l6.87-4c.72-.42.73-1.09 0-1.51l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.77 7.42a.8.8 0 000 1.51l8.9 5.17a2.88 2.88 0 002.59 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.86 2.86 0 00-2.61 0zm12.75 7.41a.79.79 0 000 1.5l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.73-.42.74-1.09 0-1.51l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.74 7.4a.8.8 0 000 1.51l8.9 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.42.73-1.09 0-1.51l-8.91-5.17a2.84 2.84 0 00-2.6 0zm12.8 7.44a.79.79 0 000 1.5l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4a.8.8 0 000-1.52l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.75 7.41a.79.79 0 000 1.5l8.91 5.17a2.85 2.85 0 002.59 0l6.86-4c.72-.41.73-1.09 0-1.5l-8.91-5.18a2.87 2.87 0 00-2.6 0zm12.74 7.4a.8.8 0 000 1.51l8.9 5.17a2.88 2.88 0 002.59 0l6.86-4c.72-.42.73-1.1 0-1.51l-8.9-5.17a2.86 2.86 0 00-2.61 0zM216.23 332.6c-.72.42-.73 1.09 0 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4c.71-.42.72-1.09 0-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zM229 340a.8.8 0 000 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.88 7.48c-.72.42-.74 1.09 0 1.5l8.9 5.18a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.85 2.85 0 00-2.59 0zm12.73 7.4a.8.8 0 000 1.51l8.91 5.17a2.84 2.84 0 002.6 0l6.86-4a.8.8 0 000-1.5l-8.98-5.13a2.9 2.9 0 00-2.6 0zm12.76 7.41c-.72.42-.74 1.09 0 1.51l59.92 34.82a2.84 2.84 0 002.6 0l6.86-4a.79.79 0 000-1.5l-59.92-34.82a2.85 2.85 0 00-2.59 0zm63.75 37.05c-.72.42-.73 1.1 0 1.51L340 406a2.86 2.86 0 002.61 0l6.86-4a.8.8 0 000-1.51l-8.9-5.17a2.88 2.88 0 00-2.59 0zm12.75 7.41c-.72.42-.73 1.09 0 1.51l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.85 2.85 0 00-2.59 0zm12.74 7.4a.8.8 0 000 1.52l8.9 5.17a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-8.9-5.17a2.87 2.87 0 00-2.6 0zm12.75 7.42a.79.79 0 000 1.5l8.9 5.17a2.86 2.86 0 002.61 0l6.86-4a.79.79 0 000-1.5l-8.9-5.18a2.88 2.88 0 00-2.59 0zm12.74 7.4a.8.8 0 000 1.51l6.9 4a2.87 2.87 0 002.6 0l6.86-4a.79.79 0 000-1.5l-6.9-4a2.84 2.84 0 00-2.6 0z"
                fill="#360707"
              />
            </g>
            <g id="prefix__monitor">
              <path
                d="M348.31 272a7.18 7.18 0 016.54 0l126.69 73.62c1.8 1.05 1.79 2.75 0 3.8l-27 14.89a7.18 7.18 0 01-6.54 0L321.26 290.7c-1.8-1.05-1.79-2.74 0-3.79z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#f73b3b"
                opacity={0.5}
              />
              <path d="M350 270.8a7 7 0 016.34 0l123.89 68.76v4.32a2.26 2.26 0 01-1.33 1.83l-26.14 14.42a7 7 0 01-6.34 0l-122.57-71.24a2.21 2.21 0 01-1.3-1.84c0-.66.08-4.57.08-4.57z" />
              <path
                d="M350 266.73a7 7 0 016.34 0L479 338c1.74 1 1.73 2.65 0 3.67l-26.14 14.41a7 7 0 01-6.34 0l-122.67-71.27c-1.74-1-1.73-2.66 0-3.67z"
                fill="#c41b1b"
              />
              <path
                d="M532.45 157.31L292.55 18.8c-1.78-1-3.38-1.07-4.51-.34l-4.79 2.84 3.11 1.81-.52 185.61a13.54 13.54 0 006.16 10.67l238.46 137.69-2.91 1.73 4 2.3 4.86-2.83a4.3 4.3 0 001.76-3.89l.45-186.39a13.58 13.58 0 00-6.17-10.69z"
                fill="#333"
              />
              <path d="M437.28 281.84v44.31l-4.3 2.33-51.71-32.91v-47.29l56.01 33.56z" />
              <path
                fill="#360707"
                d="M432.98 282.55v45.93l-56.01-32.2v-47.29l56.01 33.56z"
              />
              <path
                d="M526.7 160.19a13.56 13.56 0 016.16 10.67l-.52 186.38c0 3.93-2.79 5.51-6.21 3.54L286.22 222.27a13.61 13.61 0 01-6.16-10.68l.53-186.38c0-3.93 2.78-5.51 6.2-3.53z"
                fill="#c41b1b"
              />
              <path
                d="M287.57 192.57a15.82 15.82 0 007.2 12.45l135.29 78.11 87.65 50.61c4 2.31 7.22.46 7.24-4.12l.41-147.32a15.89 15.89 0 00-7.19-12.47L408.29 106.4 295.23 41.11c-4-2.29-7.24-.45-7.24 4.14z"
                fill="#fff"
              />
              <g opacity={0.47}>
                <path
                  d="M323.4 73.71l168 97.16a5.1 5.1 0 012.54 4.41l.14 119.23a5.1 5.1 0 01-7.66 4.42l-168-97.55a5.11 5.11 0 01-2.54-4.41l-.15-118.84a5.1 5.1 0 017.67-4.42z"
                  fill="#c41b1b"
                />
                <g opacity={0.5} fill="#fff">
                  <path d="M483.03 241.21l-162.79-94.53v1.46l162.79 94.53v-1.46zM483.05 256.54L320.26 162v1.46L483.05 258v-1.46zM483.07 271.86l-162.79-94.53v1.46l162.79 94.53v-1.46zM482.96 180.09L320.17 85.56v1.46l162.79 94.54v-1.47zM483.09 287.19L320.3 192.65v1.47l162.79 94.53v-1.46zM482.97 195.23L320.18 100.7l.01 1.46 162.79 94.53-.01-1.46zM482.99 210.56L320.2 116.03v1.46L483 212.02l-.01-1.46zM483.01 225.88l-162.79-94.53v1.46l162.79 94.53v-1.46z" />
                  <path d="M320.17 86.22l.13 106.44 1.33.77-.13-106.45-1.33-.76zM336.34 95.64l.13 106.44 1.33.77-.13-106.44-1.33-.77zM352.51 105.06l.13 106.44 1.33.77-.13-106.44-1.33-.77zM368.68 114.48l.13 106.44 1.33.77-.13-106.44-1.33-.77zM384.85 123.9l.13 106.44 1.33.77-.13-106.44-1.33-.77zM401.02 133.32l.13 106.44 1.33.77-.13-106.44-1.33-.77zM417.19 142.74l.13 106.44 1.33.77-.13-106.45-1.33-.76zM433.36 152.16l.13 106.44 1.33.77-.13-106.44-1.33-.77zM449.53 161.58l.13 106.44 1.33.77-.13-106.44-1.33-.77zM465.7 171l.13 106.44 1.33.77-.12-106.44-1.34-.77zM481.87 179.45l.13 108.56 1.33.77-.13-108.57-1.33-.76z" />
                </g>
                <path
                  fill="#fff"
                  d="M433.39 231.05l-29.58-62.38-30.02 25.49-12.96-20.6-36.94 22.92-1.22-1.27 38.56-24.49 13.11 20.86 30.57-26.03 29.43 60.97 45.97-46.17 1.52.89-48.44 49.81z"
                />
              </g>
            </g>
            <motion.g id="prefix__card1"
            
            animate={{y:[0,20,0]}}
            transition={{duration:3,loop:Infinity}}
            
            >
              <path
                d="M261.15 100.66l37.2 21.51a4.26 4.26 0 006.39-3.68V68.81a4.26 4.26 0 00-2.13-3.69l-37.2-21.51a4.25 4.25 0 00-6.41 3.68V97a4.25 4.25 0 002.15 3.66z"
                fill="#360707"
              />
              <path
                d="M284.27 82.4V66.53a1.77 1.77 0 012.65-1.53l11.79 6.82a1.77 1.77 0 01.88 1.52v15.87a1.77 1.77 0 01-2.65 1.53l-11.79-6.82a1.76 1.76 0 01-.88-1.52zm-1.89-17.63a.91.91 0 00.46-1.71l-18-10.49a.92.92 0 00-.93 1.59l18 10.49a.93.93 0 00.47.12zm-.46 4l-18-10.49a.92.92 0 11.93-1.59l18 10.49a.93.93 0 01.34 1.26.94.94 0 01-.8.46.84.84 0 01-.47-.13zm0 4.12l-18-10.49a.92.92 0 01-.33-1.26.93.93 0 011.26-.33l18 10.49a.92.92 0 01-.46 1.72.84.84 0 01-.47-.13zm0 4.13l-18-10.49a.93.93 0 01.93-1.6l18 10.49a.93.93 0 01.34 1.26.93.93 0 01-1.26.34zm0 4.12l-18-10.49a.92.92 0 01.93-1.59l18 10.49a.92.92 0 01-.92 1.59zM284.27 107.13V91.26a1.76 1.76 0 012.65-1.52l11.79 6.81a1.78 1.78 0 01.88 1.53V114a1.77 1.77 0 01-2.65 1.53l-11.79-6.82a1.78 1.78 0 01-.88-1.58zm-1.89-17.62a.92.92 0 00.46-1.72l-18-10.49a.93.93 0 00-1.26.33.92.92 0 00.33 1.26l18 10.49a.84.84 0 00.47.13zm-.46 4L263.9 83a.92.92 0 01-.33-1.26.93.93 0 011.26-.34l18 10.5a.92.92 0 01-.46 1.71.93.93 0 01-.45-.1zm0 4.12l-18-10.49a.92.92 0 01.93-1.59l18 10.49a.93.93 0 01.34 1.26.91.91 0 01-1.26.33zm0 4.12l-18-10.49a.92.92 0 01.93-1.59l18 10.49a.93.93 0 01.34 1.26.94.94 0 01-.8.46.84.84 0 01-.47-.13zm0 4.13l-18-10.5a.92.92 0 01-.33-1.26.93.93 0 011.26-.33l18 10.49a.92.92 0 01-.92 1.6z"
                fill="#fff"
              />
            </motion.g>
            <motion.g id="prefix__card2"
            
            animate={{y:[20,0,20]}}
            transition={{duration:3,loop:Infinity}}
            
            >
              <path
                d="M259.73 171.27l37.2 21.51a4.25 4.25 0 006.38-3.68v-49.69a4.25 4.25 0 00-2.12-3.68L264 114.21a4.25 4.25 0 00-6.38 3.69v49.68a4.26 4.26 0 002.11 3.69z"
                fill="#360707"
              />
              <path
                d="M282.85 153v-15.87a1.77 1.77 0 012.65-1.53l11.79 6.82a1.78 1.78 0 01.88 1.53v15.87a1.77 1.77 0 01-2.65 1.53l-11.79-6.82a1.78 1.78 0 01-.88-1.53zM281 135.38a.92.92 0 00.46-1.72l-18-10.49a.93.93 0 00-1.26.33.92.92 0 00.33 1.26l18 10.49a.84.84 0 00.47.13zm-.46 4l-18-10.49a.93.93 0 01.93-1.6l18 10.49a.92.92 0 01.33 1.26.89.89 0 01-.79.46.93.93 0 01-.51-.12zm0 4.12l-18-10.49a.92.92 0 01-.33-1.26.93.93 0 011.26-.34l18 10.5a.92.92 0 01.33 1.26.91.91 0 01-.79.45.93.93 0 01-.51-.12zm0 4.12l-18-10.49a.92.92 0 11.93-1.59l18 10.49a.92.92 0 01-.46 1.72.84.84 0 01-.51-.13zm0 4.12l-18-10.49a.92.92 0 01-.33-1.26.93.93 0 011.26-.33l18 10.49a.92.92 0 01.33 1.26.89.89 0 01-.79.46.84.84 0 01-.51-.13zM282.85 177.74v-15.87a1.77 1.77 0 012.65-1.53l11.79 6.82a1.77 1.77 0 01.88 1.53v15.87a1.77 1.77 0 01-2.65 1.52l-11.79-6.82a1.76 1.76 0 01-.88-1.52zM281 160.11a.91.91 0 00.79-.45.92.92 0 00-.33-1.26l-18-10.49a.92.92 0 10-.93 1.59l18 10.49a.93.93 0 00.47.12zm-.46 4l-18-10.49a.92.92 0 11.93-1.59l18 10.49a.92.92 0 01-.46 1.72.84.84 0 01-.51-.13zm0 4.13l-18-10.5a.92.92 0 01-.33-1.26.93.93 0 011.26-.33l18 10.49a.92.92 0 01.33 1.26.89.89 0 01-.79.46.93.93 0 01-.51-.12zm0 4.12l-18-10.49a.93.93 0 01.93-1.6l18 10.5a.92.92 0 01.33 1.26.91.91 0 01-.79.45.93.93 0 01-.51-.12zm0 4.12l-18-10.49a.92.92 0 01.93-1.59l18 10.49a.92.92 0 01-.46 1.72.94.94 0 01-.51-.13z"
                fill="#fff"
              />
            </motion.g>
            <motion.g id="prefix__card3"
             animate={{x:[0,10,0]}}
             transition={{duration:5,loop:Infinity}}
            
            >
              <path
                d="M320.71 210.83l45.54 26.34a5.21 5.21 0 007.82-4.51v-60.82a5.21 5.21 0 00-2.6-4.51L325.93 141a5.21 5.21 0 00-7.82 4.5v60.82a5.23 5.23 0 002.6 4.51z"
                fill="#360707"
              />
              <path
                d="M336.81 169.45c5-3.27 12.76-.3 17.28 6.64s4.1 15.21-.92 18.48-12.76.3-17.28-6.63-4.11-15.21.92-18.49zM332 217.38l26 15s0-19.41-3.94-26.86-13.27-10.5-17.28-6.64c-4.94 4.81-4.78 18.5-4.78 18.5z"
                fill="#fff"
              />
            </motion.g>
            <g clipPath="url(#prefix__clip-path)" id="prefix__card4">
              <path
                fill="#700a0a"
                d="M474.5 194.52l37.83 21.87v-34.41L474.5 160.1v34.42z"
              />
              <path
                fill="#c41b1b"
                d="M474.5 194.52l37.83 21.87-19.96-30.62-17.87 8.75z"
              />
              <path
                d="M494.14 188.25l18.18-6.25-37.82-21.9 16.24 26.9a2.88 2.88 0 003.4 1.25z"
                fill="#c41b1b"
              />
            </g>
            <motion.g id="prefix__bars1"
            
            animate={{scaleY:[0.5,1,0.5]}}
            transition={{duration:5,loop:Infinity}}
            style={{originX:0.5, originY:1}}
            >
              <path
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#a33535"
                opacity={0.5}
                d="M97.37 171.97l32.12 18.7 32.15-18.45-32.35-18.83-31.92 18.58z"
              />
              <path
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#c27878"
                opacity={0.5}
                d="M137.77 196.33l32.11 18.69 32.16-18.45-32.35-18.83-31.92 18.59zM179.05 219.69l32.11 18.7 15.13-8.68a11.35 11.35 0 00.06-19.65L211 201.11z"
              />
              <path
                fill="#910f0f"
                d="M102.48 172.25l24.71 14.38 24.73-14.19V14.48l-49.44-.19v157.96z"
              />
              <path
                fill="#d10000"
                d="M102.48 14.29l24.71 14.38 24.73-14.19L127.04 0l-24.56 14.29z"
              />
              <path
                fill="#9b5c5c"
                d="M127.19 186.63V28.67l24.73-14.19v157.96l-24.73 14.19z"
              />
              <g>
                <path
                  fill="#910f0f"
                  d="M144.21 196.69l24.71 14.38 24.73-14.19V60.9l-49.44-.19v135.98z"
                />
                <path
                  fill="#d10000"
                  d="M144.21 60.71l24.71 14.38 24.73-14.19-24.88-14.49-24.56 14.3z"
                />
                <path
                  fill="#9b5c5c"
                  d="M168.92 211.07V75.09l24.73-14.19v135.98l-24.73 14.19z"
                />
              </g>
              <g>
                <path
                  fill="#910f0f"
                  d="M185.94 221.14l24.71 14.38 24.73-14.19V116.17l-49.44-.19v105.16z"
                />
                <path
                  fill="#d10000"
                  d="M185.94 115.98l24.71 14.38 24.73-14.19-24.88-14.48-24.56 14.29z"
                />
                <path
                  fill="#9b5c5c"
                  d="M210.65 235.52V130.36l24.73-14.19v105.16l-24.73 14.19z"
                />
              </g>
            </motion.g>
            <motion.g id="prefix__glass"
            
            animate={{y:[0,20,0],rotate:[0,10,0]}}
            transition={{duration:3,loop:Infinity}}
            style={{originY:1,originX:1}}
            
            >
              <g
                style={{
                  isolation: "isolate",
                }}
              >
                <path
                  d="M587.87 324a3.14 3.14 0 01-.5-.54v-.06a2.12 2.12 0 01-.33-.63 2 2 0 01-.12-.67l.53 86.82v.25a2 2 0 00.05.24 1.42 1.42 0 000 .16v.05a1.89 1.89 0 00.11.25 2 2 0 00.14.25l.06.08v.05a.71.71 0 00.1.14 2.44 2.44 0 00.27.29l.13.12.13.1.16.14a5.27 5.27 0 00.58.37 6.32 6.32 0 00.91.42l.32.11.49.16.24.05h.21l.23.05.56.09H594.75l.42-.06.43-.09.21-.05h.25a4.74 4.74 0 00.5-.15l.28-.1.15-.06.14-.06a6.12 6.12 0 00.77-.38 3.08 3.08 0 001.78-2.55l-.39-86.79a3.09 3.09 0 01-1.78 2.55 6.38 6.38 0 01-.91.44l-.15.06c-.3.11-.62.21-.94.3h-.09c-.36.08-.72.15-1.09.2a10.73 10.73 0 01-1.14.07 8.4 8.4 0 01-1.12-.05h-.1a8.33 8.33 0 01-1-.16h-.2c-.25-.06-.49-.14-.73-.22l-.32-.1a7.77 7.77 0 01-.92-.42 4.68 4.68 0 01-.73-.51z"
                  fill="#333"
                />
                <path
                  d="M588.73 324.66c-2.45-1.38-2.48-3.67-.09-5.09a9.71 9.71 0 018.8-.09c2.44 1.38 2.47 3.66.07 5.09a9.73 9.73 0 01-8.78.09z"
                  fill="#9391ea"
                />
              </g>
              <path
                d="M558.87 233.45l10-5.72.41-.23.42-.2.73-.35.65-.28.75-.29.27-.1.42-.12.77-.23.71-.17.79-.17.35-.07h.38c.29 0 .58-.08.87-.11l.74-.07h3.43c.42 0 .85.08 1.28.14h.54c.69.1 1.38.24 2.08.39l.56.14c.54.13 1.08.28 1.64.44l.36.1.39.13 1 .33.89.33 1 .4c.3.12.61.25.91.39s.66.3 1 .46.62.29.93.45.67.34 1 .53.41.2.62.32l.65.37c1.16.66 2.29 1.4 3.42 2.16l.89.62c1 .71 2 1.45 3 2.23l.36.29c.88.71 1.74 1.45 2.59 2.22.16.14.3.29.45.43.69.64 1.37 1.31 2 2 .52.51 1 1 1.54 1.54.68.72 1.35 1.47 2 2.23.39.43.79.85 1.17 1.3.1.11.19.23.29.35l.58.72c.78 1 1.55 1.93 2.29 2.93.22.29.44.57.65.87l.41.54c.71 1 1.39 2 2.06 3 .15.23.3.45.44.68.27.41.54.82.8 1.23s.48.84.73 1.26c.5.84 1 1.68 1.47 2.53.18.31.38.62.55.94s.4.8.61 1.2c.42.8.83 1.61 1.23 2.42.18.36.37.71.54 1.07s.33.78.51 1.16q.55 1.23 1.08 2.46c.16.39.35.77.5 1.16s.26.72.39 1.07c.35.9.68 1.79 1 2.7.15.42.32.84.47 1.27s.32 1 .47 1.54c.07.23.15.46.22.69.32 1.08.63 2.17.9 3.26.06.25.11.5.17.75s.17.76.26 1.14c.25 1.12.47 2.24.66 3.35.05.33.12.65.17 1 0 .15.06.31.08.46.13.87.2 1.72.29 2.58.05.5.13 1 .17 1.49.12 1.48.18 2.95.18 4.39 0 12.11-4.28 20.62-11.18 24.57l-10 5.72z"
                fill="#333"
              />
              <path
                d="M547.69 258c0-24 16.9-33.92 37.65-22S623 277.19 623 301.24s-16.9 33.91-37.65 22-37.68-41.18-37.66-65.24zm70.15 41.08c-.38-21-15.28-46.82-33.2-57.56s-32.21-2.4-31.84 18.61S568.07 307 586 317.71s32.21 2.39 31.84-18.61"
                fill="#666"
              />
              <path
                d="M617.84 299.1c.37 21-13.92 29.35-31.84 18.61s-32.82-36.57-33.2-57.56 13.9-29.35 31.84-18.61 32.82 36.56 33.2 57.56"
                fill="#fff"
              />
              <path
                d="M556.57 258c.37 21 15.26 46.82 33.19 57.56 8 4.76 15.18 5.76 20.73 3.58-5.82 4.62-14.6 4.52-24.49-1.41-17.93-10.74-32.82-36.57-33.2-57.56-.21-11.7 4.13-19.46 11.11-22.2-4.73 3.73-7.51 10.59-7.34 20.03z"
                fill="#333"
              />
            </motion.g>
            <motion.g id="prefix__person2"
            
            animate={{x:[0,10,0]}}
            transition={{duration:5,loop:Infinity}}
            
            >
              <path
                d="M305.41 316.85l22.43 13.07a5.71 5.71 0 010 9.89L324 342a11.81 11.81 0 01-11.8-.06l-22.43-13.07a5.71 5.71 0 010-9.89l3.83-2.18a11.84 11.84 0 0111.81.05z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#6642cc"
                opacity={0.3}
              />
              <path
                d="M296.65 320.6s.92-3.08 6.41-2.07c.91.17 1.86 4 1.86 4l10 3s-19 7.1-18.83 4.05c.26-4.58.56-8.98.56-8.98z"
                fill="#130159"
              />
              <path
                d="M293.61 240.71l3 80.74c1.82 2.47 8 .39 8 .39.31-2.38 6.19-76.8 6.19-76.8z"
                fill="#5601f3"
              />
              <path
                d="M332.18 192.11c1.3.59 1.51-.88 1.69-2a6.7 6.7 0 01.46-1.72c.22-.11.54 1.28.74.88s2.68-4 4.6-1.78c1 1.13-1.87 4.74-3 5.28-2.17 1-2.58 0-4 1.7z"
                fill="#f4c5a2"
              />
              <path
                d="M311.76 194.89a25.77 25.77 0 009.83 4.14l11.78-8.49s1.59-.65 2.16 3.23c0 0-12.08 13.74-14.75 14.07s-6.55-1.59-12.88-5.09c-10.73-5.92-1.69-11.57 3.86-7.86z"
                fill="#00cdc4"
              />
              <path
                d="M306.42 324.62s.92-3.08 6.4-2.07c.91.16 1.86 3.95 1.86 3.95l10 3s-19 7.1-18.83 4.05c.27-4.55.57-8.93.57-8.93z"
                fill="#130159"
              />
              <path
                d="M303.42 247l3 78.27c1.81 2.47 8 .39 8 .39.31-2.38 6.19-76.8 6.19-76.8z"
                fill="#681ef7"
              />
              <g>
                <path
                  fill="#fed4bd"
                  d="M312.24 185.64l1.2 7.39-6.99-.49 1.37-6.24 4.42-.66z"
                />
                <path
                  fill="#fff"
                  d="M315.72 191.46l-9.96-1.24-1.13 4.02 11.48.53-.39-3.31z"
                />
                <path
                  d="M314.67 180.1c.51 3.52-.47 7.37-4.25 7.13a6.42 6.42 0 01-6.1-5.63c-.51-3.53 1.39-6.72 4.25-7.13s5.59 2.1 6.1 5.63z"
                  fill="#fed4bd"
                />
                <path
                  d="M307.3 187.81s1.32 1.05 3.12-.58a11.29 11.29 0 001-3.4c0-.91-1.31-2.05-1-2.83.58-1.52 2-1.24 2.38 1.72.16-1.39 7.6-5 3-8.38-6-4.37-15.18-.52-12 5.12-2.74.76 1.26 5.88 3.5 8.35z"
                  fill="#3d00bd"
                />
              </g>
              <path
                d="M319.16 198.05c1.21 4 2.89 36.93 5.48 49.2-4.82 6.18-27.18 7.53-33.54.33 0 0 1.82-24.28 8.51-46.92 2.82-9.57 11.45-12.79 19.55-2.61z"
                fill="#01e4d0"
              />
              <g>
                <path
                  d="M344 200.41c1.85.37 2.45-1.93 3-3 1.8-3.86 1.43-1.1 1.7-1 .72.17 4-1.4 4.38.37.46 2-2.11 3.37-3.56 4.14-2.81 1.51-2.79-.11-4.44 1.91z"
                  fill="#f4c5a2"
                />
                <path
                  d="M317 195.28c9.17 9.8 10 11 10 11l18.84-7.82s3.59.46 2.31 4.44c0 0-17.44 14.77-21.75 14.5s-9.93-6.73-16.19-13.78c-8.42-9.48.9-14.62 6.79-8.34z"
                  fill="#01e4d0"
                />
              </g>
            </motion.g>
            <g id="prefix__circle1">
              <path
                d="M133.6 198.78c-57.53 0-104.17 25.36-104.17 56.64s46.64 56.63 104.17 56.63 104.16-25.36 104.16-56.63-46.63-56.64-104.16-56.64zm0 90.76c-41.52 0-75.18-15.28-75.18-34.12s33.66-34.13 75.18-34.13 75.18 15.28 75.18 34.13-33.66 34.12-75.18 34.12z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#c27878"
                opacity={0.5}
              />
              <path
                d="M235.65 215.32S220.24 177.1 133.6 177.1s-102 56-102 56v19.22c0 30.65 45.69 55.49 102.05 55.49s102-24.81 102-55.46zM133.6 285.78c-40.68 0-73.66-15-73.66-33.43s33-33.42 73.66-33.42 73.66 15 73.66 33.42-32.98 33.43-73.66 33.43z"
                fill="#910f0f"
              />
              <path
                d="M133.6 159.83c-56.36 0-102 24.85-102 55.49s45.69 55.49 102.05 55.49 102-24.81 102-55.49S190 159.83 133.6 159.83zm0 88.92c-40.68 0-73.66-15-73.66-33.43s33-33.43 73.66-33.43 73.66 15 73.66 33.43-32.98 33.43-73.66 33.43z"
                fill="#bf7474"
              />
              <path
                d="M195.24 248.84C182.09 258 159.4 264 133.6 264h-1.91v43.86h1.91c38.23 0 71.53-11.44 89-28.36v-37s-24.44 7.25-27.36 6.34z"
                fill="#a80202"
              />
              <path
                d="M195.24 233.61c-13.15 9.11-35.84 15.14-61.64 15.14h-1.91v22.06h1.91c38.23 0 71.53-11.44 89-28.36-6.22-2-12.42-4.06-18.62-6.1-2.9-.95-5.82-1.83-8.74-2.74z"
                fill="#f60303"
              />
              <g>
                <path d="M132.11 270.34C96.65 271.61 58.39 251.55 60 232c-9.51 0-28.47-15.23-28.47-15.23v35.62c0 30.37 44.88 55 100.56 55.47z" />
                <path
                  d="M132.11 248.73c-38.94-.35-70.46-14.41-72.09-32H31.61c1.39 29.7 45.7 53.61 100.5 54z"
                  fill="#242424"
                />
              </g>
            </g>
            <g id="prefix__person1">
              <path
                d="M387.92 356.61l3.54 2a5.27 5.27 0 010 9.13l-20.7 12.07a10.91 10.91 0 01-10.9.05l-3.53-2a5.27 5.27 0 01-.05-9.13L377 356.66a10.89 10.89 0 0110.92-.05z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#6642cc"
                opacity={0.3}
              />
              <path
                d="M365.88 258.94a44.71 44.71 0 01-4.62-2.57c-.51-.52-2.3-2.69-3.48-2.76-.74 0-.14.58.37 1.4 1.18 1.9-3.08-1.77-4.1-.3-.65.95-.07 4.48 4.89 5.41 2.09.38 4.23 2.15 5.11 2.45z"
                fill="#f4c5a2"
              />
              <path
                d="M377.64 250c1.87 10.43 4.32 16 4.32 16l-20.58-10.17s-4.25-.87-2.4 4.95c0 0 26.23 17.46 35 11.77 4.68-3-1.35-25.52-8.64-29.17-3.86-1.24-9.27-2.18-7.7 6.62z"
                fill="#f6dd03"
              />
              <path
                fill="#fed4bd"
                d="M372.07 236.1v7.62l6.05-.73-2.28-7.75-3.77.86z"
              />
              <path
                fill="#fffaff"
                d="M372.13 240.12l5.86-.84 1.4 3.28-8.55 1.28 1.29-3.72z"
              />
              <path
                d="M385.73 361.16s-2.39-1-7.26.47c-3.26 1-10.72 3.69-10.72 3.69s18 4.91 18 2.13c.03-4.16-.02-6.29-.02-6.29z"
                fill="#130159"
              />
              <path
                d="M375.42 366.49a45.43 45.43 0 00-7.26.47c-2.16.26-10.72 3.69-10.72 3.69s18 4.91 18 2.13c.03-4.15-.02-6.29-.02-6.29z"
                fill="#130159"
              />
              <path
                d="M391.3 286.55l-4.16 75.38s-3.95 1.85-9.53-.63l-.55-73.37z"
                fill="#5601f3"
              />
              <path
                d="M382.53 289.2l-5.88 78.8c-8.23.94-8.69-1.58-8.69-1.58.46-4.5-1.75-80.66-1.75-80.66z"
                fill="#681ef7"
              />
              <path
                d="M368 230.92c.35 3.54 2.21 7 5.82 5.89a6.39 6.39 0 004.56-6.91c-.34-3.54-2.95-6.17-5.82-5.89s-4.96 3.38-4.56 6.91z"
                fill="#fed4bd"
              />
              <path
                d="M376.93 236.63s-1 1.33-3.16.18a11.16 11.16 0 01-1.78-3.05c-.19-.88.78-2.3.3-3-.92-1.33-2.22-.72-1.89 2.24-.49-1.32-8.57-3-4.88-7.41 4.78-5.67 14.58-4.14 12.85 2.08 2.79.12.14 6.03-1.44 8.96z"
                fill="#3d00bd"
              />
              <path
                d="M364.77 247s1.58 30.07 1.58 46.38c6 5.43 25.83.78 27.15-2.39s-.63-5.95-1.15-9.69c-1.66-11.95-.08-27.69-3.29-33.67-4.33-8.06-14.55-8.63-24.29-.63z"
                fill="#f6bf03"
              />
              <path
                fill="#3d00bd"
                d="M371.81 305.5l-19.67-11.8v18.75l19.31 11.26.36-18.21z"
              />
              <path d="M352.65 300.84s-1-.62-1-.5v6.2l1 .4z" fill="#7676e5" />
              <path
                d="M358.64 301.9c-1.65 2.15-2.9 8.72 1.09 9.47 1.17.22 3.41-4.31 3.62-7.87"
                fill="#f4c5a2"
              />
              <path
                d="M362.2 252.4c1.67-8.74 8.08-8.85 9 5.6.49 7.34.31 11.36-.74 20.44-.78 6.82-6.21 26.7-6.25 26.73-.73.62-6.37-2-6.53-4.19 2.76-9 3.51-11.69 4.37-23.46.78-9.97-1.12-18.44.15-25.12z"
                fill="#f6dd03"
              />
            </g>
            <motion.g id="prefix__personwithcoins"
            
            animate={{y:[0,20,0]}}
            transition={{duration:3,loop:Infinity}}
            
            >
              <g id="prefix__coins">
                <g fill="#f67b7b">
                  <path
                    d="M417.37 467c0 8 12.23 14.5 27.32 14.5S472 475 472 467s-12.23-14.5-27.31-14.5-27.32 6.5-27.32 14.5z"
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    opacity={0.5}
                  />
                  <path
                    d="M451.21 451.6c0 8 12.23 14.51 27.32 14.51s27.31-6.5 27.31-14.51-12.23-14.5-27.31-14.5-27.32 6.5-27.32 14.5z"
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    opacity={0.5}
                  />
                  <path
                    d="M477 476.11c0 8 12.23 14.51 27.32 14.51s27.31-6.5 27.31-14.51-12.23-14.5-27.31-14.5-27.32 6.5-27.32 14.5z"
                    style={{
                      mixBlendMode: "multiply",
                    }}
                    opacity={0.5}
                  />
                </g>
                <path
                  d="M502.63 442.73v5.61c0 7.57-11.29 13.7-25.21 13.7s-25.21-6.13-25.21-13.7v-5.61z"
                  fill="#c74848"
                />
                <path
                  d="M490.23 460.1c-.8.27-1.63.52-2.5.73v-14.1h2.5zm-25.59 0c.81.27 1.63.53 2.5.74v-14.1h-2.5zm32.18-3.07a14.61 14.61 0 004.4-4.26v-9.44h-4.4z"
                  style={{
                    mixBlendMode: "screen",
                  }}
                  fill="#de0000"
                  opacity={0.41}
                />
                <path
                  d="M452.21 442.73c0 7.57 11.29 13.71 25.21 13.71s25.21-6.14 25.21-13.71S491.34 429 477.42 429s-25.21 6.17-25.21 13.73z"
                  fill="#8f0a0a"
                />
                <path
                  d="M458 442.56c0 5.69 8.68 10.31 19.4 10.31s19.4-4.62 19.4-10.31-8.68-10.3-19.4-10.3-19.4 4.61-19.4 10.3z"
                  fill="#d43131"
                />
                <path
                  d="M477.42 433.69c10.26 0 18.64 4.23 19.34 9.59a5.83 5.83 0 00.06-.72c0-5.69-8.68-10.3-19.4-10.3s-19.4 4.61-19.4 10.3a5.83 5.83 0 00.06.72c.7-5.36 9.08-9.59 19.34-9.59z"
                  fill="#c74848"
                />
                <path
                  d="M486 438.39l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.88-.43-3.44 2-1.15 4.1.6 5.82l-3.46 2c-.52-.59-.41-1.16.41-1.73l-4-2.32c-2.74 1.71-2.11 3.87.64 5.76l-1.8 1.05 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.09-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4 2.33c2.62-1.71 2.22-3.72-.58-5.61zm-9.82 7.37a3.46 3.46 0 01-3 .07l3.11-1.81c.55.69.71 1.28-.1 1.74zm2.45-4.72c-.46-.66-.52-1.23.25-1.68a3.13 3.13 0 012.8-.09z"
                  fill="#c74848"
                />
                <path
                  d="M486 437.74l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.88-.42-3.44 2-1.15 4.09.6 5.82l-3.46 2c-.52-.58-.41-1.16.41-1.73l-4-2.32c-2.74 1.71-2.11 3.87.64 5.77l-1.8 1.05 1.4.8 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.08-.7-5.83l3.4-2c.41.48.32 1-.4 1.54l4 2.34c2.62-1.73 2.22-3.75-.58-5.64zm-9.82 7.37a3.46 3.46 0 01-3 .07l3.11-1.8c.55.68.71 1.27-.1 1.73zm2.45-4.71c-.46-.67-.52-1.24.25-1.68a3.1 3.1 0 012.8-.1z"
                  fill="#8f0a0a"
                />
                <path
                  d="M502.63 434.25v5.6c0 7.57-11.29 13.71-25.21 13.71s-25.21-6.14-25.21-13.71v-5.6z"
                  fill="#c74848"
                />
                <path
                  d="M490.23 451.61c-.8.27-1.63.53-2.5.74v-14.1h2.5zm-25.59.06c.81.27 1.63.52 2.5.73v-14.1h-2.5zm32.18-3.07a14.64 14.64 0 004.4-4.27v-9.43h-4.4z"
                  style={{
                    mixBlendMode: "screen",
                  }}
                  fill="#de0000"
                  opacity={0.41}
                />
                <path
                  d="M452.21 434.25c0 7.57 11.29 13.71 25.21 13.71s25.21-6.14 25.21-13.71-11.29-13.71-25.21-13.71-25.21 6.14-25.21 13.71z"
                  fill="#8f0a0a"
                />
                <path
                  d="M458 434.08c0 5.69 8.68 10.3 19.4 10.3s19.4-4.61 19.4-10.3-8.68-10.3-19.4-10.3-19.4 4.61-19.4 10.3z"
                  fill="#d43131"
                />
                <path
                  d="M477.42 425.21c10.26 0 18.64 4.23 19.34 9.58a5.51 5.51 0 00.06-.71c0-5.69-8.68-10.3-19.4-10.3s-19.4 4.61-19.4 10.3a5.51 5.51 0 00.06.71c.7-5.35 9.08-9.58 19.34-9.58z"
                  fill="#c74848"
                />
                <path
                  d="M486 429.91l1.77-1-1.4-.81-1.78 1c-3.2-1.62-7.14-2-9.88-.42-3.44 2-1.15 4.09.6 5.82l-3.46 2c-.52-.58-.41-1.15.41-1.72l-4-2.33c-2.74 1.71-2.11 3.88.64 5.77l-1.8 1 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.09-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4 2.33c2.62-1.68 2.22-3.7-.58-5.58zm-9.82 7.36a3.46 3.46 0 01-3 .07l3.11-1.8c.55.69.71 1.28-.1 1.73zm2.45-4.71c-.46-.67-.52-1.24.25-1.68a3.1 3.1 0 012.8-.09z"
                  fill="#c74848"
                />
                <path
                  d="M486 429.26l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.88-.43-3.44 2-1.15 4.1.6 5.82l-3.46 2c-.52-.58-.41-1.15.41-1.72l-4-2.32c-2.74 1.71-2.11 3.87.64 5.76l-1.8 1.05 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.09-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4 2.33c2.62-1.72 2.22-3.73-.58-5.62zm-9.82 7.37a3.49 3.49 0 01-3 .07l3.11-1.81c.55.69.71 1.28-.1 1.74zm2.45-4.72c-.46-.66-.52-1.23.25-1.68a3.13 3.13 0 012.8-.09z"
                  fill="#8f0a0a"
                />
                <g>
                  <path
                    d="M502.63 425.77v5.6c0 7.57-11.29 13.7-25.21 13.7s-25.21-6.13-25.21-13.7v-5.6z"
                    fill="#c74848"
                  />
                  <path
                    d="M490.23 443.13c-.8.27-1.63.52-2.5.73v-14.1h2.5zm-25.59.05c.81.27 1.63.53 2.5.74v-14.1h-2.5zm32.18-3.07a14.61 14.61 0 004.4-4.26v-9.44h-4.4z"
                    style={{
                      mixBlendMode: "screen",
                    }}
                    fill="#de0000"
                    opacity={0.41}
                  />
                  <path
                    d="M452.21 425.77c0 7.56 11.29 13.7 25.21 13.7s25.21-6.14 25.21-13.7-11.29-13.71-25.21-13.71-25.21 6.14-25.21 13.71z"
                    fill="#8f0a0a"
                  />
                  <path
                    d="M458 425.59c0 5.69 8.68 10.31 19.4 10.31s19.4-4.62 19.4-10.31-8.68-10.3-19.4-10.3-19.4 4.62-19.4 10.3z"
                    fill="#d43131"
                  />
                  <path
                    d="M477.42 416.72c10.26 0 18.64 4.24 19.34 9.59a5.83 5.83 0 00.06-.72c0-5.68-8.68-10.3-19.4-10.3s-19.4 4.62-19.4 10.3a5.83 5.83 0 00.06.72c.7-5.31 9.08-9.59 19.34-9.59z"
                    fill="#c74848"
                  />
                  <path
                    d="M486 421.42l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.88-.43-3.44 2-1.15 4.1.6 5.82l-3.46 2c-.52-.58-.41-1.16.41-1.73l-4-2.32c-2.74 1.71-2.11 3.87.64 5.77l-1.8 1 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.08-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4 2.34c2.62-1.68 2.22-3.69-.58-5.58zm-9.82 7.37a3.46 3.46 0 01-3 .07l3.11-1.8c.55.68.71 1.27-.1 1.73zm2.45-4.71c-.46-.67-.52-1.24.25-1.68a3.1 3.1 0 012.8-.1z"
                    fill="#c74848"
                  />
                  <path
                    d="M486 420.78l1.77-1-1.4-.81-1.78 1c-3.2-1.62-7.14-2-9.88-.42-3.44 2-1.15 4.09.6 5.82l-3.46 2c-.52-.58-.41-1.16.41-1.72l-4-2.33c-2.74 1.71-2.11 3.88.64 5.77l-1.8 1.05 1.4.81 1.78-1c3.64 1.93 7.63 1.81 10 .44 3.4-2 1-4.09-.7-5.84l3.4-2c.41.49.32 1-.4 1.55l4 2.33c2.62-1.75 2.22-3.77-.58-5.65zm-9.82 7.36a3.46 3.46 0 01-3 .07l3.11-1.8c.55.69.71 1.27-.1 1.73zm2.45-4.71c-.46-.67-.52-1.24.25-1.68a3.07 3.07 0 012.8-.09z"
                    fill="#8f0a0a"
                  />
                </g>
                <g>
                  <path
                    d="M502.63 417.28v5.6c0 7.57-11.29 13.71-25.21 13.71s-25.21-6.14-25.21-13.71v-5.6z"
                    fill="#c74848"
                  />
                  <path
                    d="M490.23 434.64c-.8.27-1.63.53-2.5.74v-14.1h2.5zm-25.59.06c.81.27 1.63.52 2.5.74v-14.11h-2.5zm32.18-3.07a14.73 14.73 0 004.4-4.26v-9.44h-4.4z"
                    style={{
                      mixBlendMode: "screen",
                    }}
                    fill="#de0000"
                    opacity={0.41}
                  />
                  <path
                    d="M452.21 417.28c0 7.57 11.29 13.71 25.21 13.71s25.21-6.14 25.21-13.71-11.29-13.7-25.21-13.7-25.21 6.13-25.21 13.7z"
                    fill="#8f0a0a"
                  />
                  <path
                    d="M458 417.11c0 5.69 8.68 10.3 19.4 10.3s19.4-4.61 19.4-10.3-8.68-10.3-19.4-10.3-19.4 4.61-19.4 10.3z"
                    fill="#d43131"
                  />
                  <path
                    d="M477.42 408.24c10.26 0 18.64 4.23 19.34 9.58a5.51 5.51 0 00.06-.71c0-5.69-8.68-10.3-19.4-10.3s-19.4 4.61-19.4 10.3a5.51 5.51 0 00.06.71c.7-5.35 9.08-9.58 19.34-9.58z"
                    fill="#c74848"
                  />
                  <path
                    d="M486 412.94l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.88-.43-3.44 2-1.15 4.09.6 5.82l-3.46 2c-.52-.58-.41-1.15.41-1.72l-4-2.32c-2.74 1.7-2.11 3.87.64 5.76l-1.8 1.05 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.09-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4 2.33c2.62-1.72 2.22-3.73-.58-5.62zm-9.82 7.37a3.49 3.49 0 01-3 .07l3.11-1.81c.55.69.71 1.28-.1 1.74zm2.45-4.72c-.46-.66-.52-1.23.25-1.68a3.1 3.1 0 012.8-.09z"
                    fill="#c74848"
                  />
                  <path
                    d="M486 412.29l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.88-.43-3.44 2-1.15 4.1.6 5.82l-3.46 2c-.52-.59-.41-1.16.41-1.73l-4-2.32c-2.74 1.71-2.11 3.87.64 5.77l-1.8 1 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.08-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4 2.34c2.62-1.68 2.22-3.69-.58-5.58zm-9.82 7.37a3.46 3.46 0 01-3 .07l3.11-1.8c.55.68.71 1.27-.1 1.73zm2.45-4.72c-.46-.66-.52-1.23.25-1.68a3.13 3.13 0 012.8-.09z"
                    fill="#8f0a0a"
                  />
                </g>
                <g>
                  <path
                    d="M502.63 408.8v5.6c0 7.57-11.29 13.71-25.21 13.71s-25.21-6.11-25.21-13.71v-5.6z"
                    fill="#c74848"
                  />
                  <path
                    d="M490.23 426.16c-.8.27-1.63.52-2.5.74v-14.11h2.5zm-25.59.06c.81.27 1.63.52 2.5.73v-14.1h-2.5zm32.18-3.08a14.61 14.61 0 004.4-4.26v-9.43h-4.4z"
                    style={{
                      mixBlendMode: "screen",
                    }}
                    fill="#de0000"
                    opacity={0.41}
                  />
                  <path
                    d="M452.21 408.8c0 7.57 11.29 13.7 25.21 13.7s25.21-6.13 25.21-13.7-11.29-13.71-25.21-13.71-25.21 6.14-25.21 13.71z"
                    fill="#8f0a0a"
                  />
                  <path
                    d="M458 408.63c0 5.69 8.68 10.3 19.4 10.3s19.4-4.61 19.4-10.3-8.68-10.3-19.4-10.3-19.4 4.61-19.4 10.3z"
                    fill="#d43131"
                  />
                  <path
                    d="M477.42 399.75c10.26 0 18.64 4.24 19.34 9.59a5.67 5.67 0 00.06-.71c0-5.69-8.68-10.3-19.4-10.3s-19.4 4.61-19.4 10.3a5.67 5.67 0 00.06.71c.7-5.34 9.08-9.59 19.34-9.59z"
                    fill="#c74848"
                  />
                  <path
                    d="M486 404.45l1.77-1-1.4-.81-1.78 1c-3.2-1.62-7.14-2-9.88-.42-3.44 2-1.15 4.09.6 5.82l-3.46 2c-.52-.58-.41-1.16.41-1.73l-4-2.32c-2.74 1.71-2.11 3.87.64 5.77l-1.8 1.05 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.08-.7-5.83l3.4-2c.41.48.32 1-.4 1.55l4 2.33c2.62-1.74 2.22-3.76-.58-5.65zm-9.82 7.37a3.46 3.46 0 01-3 .07l3.11-1.8c.55.68.71 1.27-.1 1.73zm2.45-4.71c-.46-.67-.52-1.24.25-1.68a3.07 3.07 0 012.8-.09z"
                    fill="#c74848"
                  />
                  <path
                    d="M486 403.81l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.88-.43-3.44 2-1.15 4.09.6 5.82l-3.46 2c-.52-.58-.41-1.15.41-1.72l-4-2.33c-2.74 1.71-2.11 3.88.64 5.77l-1.8 1.05 1.4.81 1.78-1c3.64 1.92 7.63 1.81 10 .43 3.4-2 1-4.09-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4 2.33c2.62-1.72 2.22-3.73-.58-5.62zm-9.82 7.36a3.46 3.46 0 01-3 .08l3.11-1.81c.55.69.71 1.28-.1 1.73zm2.45-4.71c-.46-.67-.52-1.23.25-1.68a3.1 3.1 0 012.8-.09z"
                    fill="#8f0a0a"
                  />
                </g>
                <g>
                  <path
                    d="M529.51 467.26v5.61c0 7.56-11.28 13.7-25.2 13.7s-25.21-6.14-25.21-13.7v-5.61z"
                    fill="#c74848"
                  />
                  <path
                    d="M517.12 484.63c-.8.27-1.63.52-2.5.73v-14.1h2.5zm-25.59.05c.8.27 1.63.53 2.5.74v-14.1h-2.5zm32.18-3.07a14.61 14.61 0 004.4-4.26v-9.44h-4.4z"
                    style={{
                      mixBlendMode: "screen",
                    }}
                    fill="#de0000"
                    opacity={0.41}
                  />
                  <path
                    d="M479.1 467.26c0 7.57 11.29 13.71 25.21 13.71s25.2-6.14 25.2-13.71-11.28-13.7-25.2-13.7-25.21 6.14-25.21 13.7z"
                    fill="#8f0a0a"
                  />
                  <path
                    d="M484.9 467.09c0 5.69 8.69 10.31 19.41 10.31s19.4-4.62 19.4-10.31-8.69-10.3-19.4-10.3-19.41 4.61-19.41 10.3z"
                    fill="#d43131"
                  />
                  <path
                    d="M504.31 458.22c10.26 0 18.64 4.23 19.33 9.59a5.85 5.85 0 00.07-.72c0-5.69-8.69-10.3-19.4-10.3s-19.41 4.61-19.41 10.3a5.85 5.85 0 00.07.72c.69-5.36 9.03-9.59 19.34-9.59z"
                    fill="#c74848"
                  />
                  <path
                    d="M512.89 462.92l1.78-1-1.41-.81-1.77 1c-3.21-1.63-7.15-2-9.88-.43-3.44 2-1.15 4.1.59 5.82l-3.46 2c-.51-.58-.4-1.15.42-1.72l-4-2.32c-2.73 1.71-2.1 3.87.64 5.76l-1.8 1 1.41.81 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.39-2 1-4.09-.7-5.84l3.4-2c.4.48.32 1-.4 1.54l4 2.33c2.6-1.67 2.21-3.68-.59-5.57zm-9.81 7.37a3.49 3.49 0 01-3 .07l3.1-1.81c.55.69.69 1.28-.1 1.74zm2.44-4.72c-.45-.66-.51-1.23.26-1.68a3.11 3.11 0 012.79-.09z"
                    fill="#c74848"
                  />
                  <path
                    d="M512.89 462.27l1.78-1-1.41-.81-1.77 1c-3.21-1.63-7.15-2-9.88-.42-3.44 2-1.15 4.09.59 5.81l-3.46 2c-.51-.58-.4-1.16.42-1.73l-4-2.32c-2.73 1.71-2.1 3.87.64 5.77l-1.8 1 1.41.81 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.39-2 1-4.08-.7-5.83l3.4-2c.4.48.32 1-.4 1.54l4 2.34c2.6-1.69 2.21-3.7-.59-5.59zm-9.81 7.37a3.46 3.46 0 01-3 .07l3.1-1.8c.55.68.69 1.27-.1 1.73zm2.44-4.71c-.45-.67-.51-1.24.26-1.68a3.08 3.08 0 012.79-.1z"
                    fill="#8f0a0a"
                  />
                </g>
                <g>
                  <path
                    d="M529.51 458.81v5.61c0 7.56-11.28 13.7-25.2 13.7s-25.21-6.12-25.21-13.7v-5.61z"
                    fill="#c74848"
                  />
                  <path
                    d="M517.12 476.17c-.8.27-1.63.53-2.5.74v-14.1h2.5zm-25.59.06c.8.27 1.63.52 2.5.74v-14.1h-2.5zm32.18-3.07a14.61 14.61 0 004.4-4.26v-9.44h-4.4z"
                    style={{
                      mixBlendMode: "screen",
                    }}
                    fill="#de0000"
                    opacity={0.41}
                  />
                  <path
                    d="M479.1 458.81c0 7.57 11.29 13.71 25.21 13.71s25.2-6.14 25.2-13.71-11.28-13.7-25.2-13.7-25.21 6.13-25.21 13.7z"
                    fill="#8f0a0a"
                  />
                  <path
                    d="M484.9 458.64c0 5.69 8.69 10.3 19.41 10.3s19.4-4.61 19.4-10.3-8.69-10.3-19.4-10.3-19.41 4.66-19.41 10.3z"
                    fill="#d43131"
                  />
                  <path
                    d="M504.31 449.77c10.26 0 18.64 4.23 19.33 9.58a5.51 5.51 0 00.07-.71c0-5.69-8.69-10.3-19.4-10.3s-19.41 4.66-19.41 10.3a5.51 5.51 0 00.07.71c.69-5.35 9.03-9.58 19.34-9.58z"
                    fill="#c74848"
                  />
                  <path
                    d="M512.89 454.47l1.78-1-1.41-.8-1.77 1c-3.21-1.63-7.15-2-9.88-.43-3.44 2-1.15 4.1.59 5.82l-3.46 2c-.51-.58-.4-1.15.42-1.72l-4-2.32c-2.73 1.71-2.1 3.87.64 5.76l-1.8 1.05 1.41.81 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.39-2 1-4.09-.7-5.84l3.4-2c.4.48.32 1-.4 1.54l4 2.33c2.6-1.73 2.21-3.74-.59-5.63zm-9.81 7.37a3.49 3.49 0 01-3 .07l3.1-1.81c.55.69.69 1.28-.1 1.74zm2.44-4.72c-.45-.66-.51-1.23.26-1.68a3.08 3.08 0 012.79-.09z"
                    fill="#c74848"
                  />
                  <path
                    d="M512.89 453.82l1.78-1-1.41-.81-1.77 1c-3.21-1.63-7.15-2-9.88-.43-3.44 2-1.15 4.1.59 5.82l-3.46 2c-.51-.59-.4-1.16.42-1.73l-4-2.32c-2.73 1.71-2.1 3.87.64 5.77l-1.8 1 1.41.81 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.39-2 1-4.08-.7-5.84l3.4-2c.4.48.32 1-.4 1.54l4 2.34c2.6-1.68 2.21-3.69-.59-5.58zm-9.81 7.37a3.46 3.46 0 01-3 .07l3.1-1.8c.55.68.69 1.27-.1 1.73zm2.44-4.71c-.45-.67-.51-1.24.26-1.68a3.08 3.08 0 012.79-.1z"
                    fill="#8f0a0a"
                  />
                </g>
                <g>
                  <path
                    d="M469.89 458.09v5.6c0 7.57-11.28 13.71-25.2 13.71s-25.21-6.14-25.21-13.71v-5.6z"
                    fill="#c74848"
                  />
                  <path
                    d="M457.5 475.45c-.81.27-1.63.52-2.5.74v-14.11h2.5zm-25.59.06c.8.27 1.63.52 2.5.73v-14.1h-2.5zm32.18-3.08a14.57 14.57 0 004.39-4.26v-9.43h-4.39z"
                    style={{
                      mixBlendMode: "screen",
                    }}
                    fill="#de0000"
                    opacity={0.41}
                  />
                  <path
                    d="M419.48 458.09c0 7.57 11.28 13.7 25.21 13.7s25.2-6.13 25.2-13.7-11.28-13.71-25.2-13.71-25.21 6.14-25.21 13.71z"
                    fill="#8f0a0a"
                  />
                  <path
                    d="M425.28 457.92c0 5.69 8.69 10.3 19.41 10.3s19.4-4.61 19.4-10.3-8.69-10.31-19.4-10.31-19.41 4.62-19.41 10.31z"
                    fill="#d43131"
                  />
                  <path
                    d="M444.69 449c10.26 0 18.64 4.24 19.33 9.59a5.69 5.69 0 00.07-.71c0-5.69-8.69-10.31-19.4-10.31s-19.41 4.62-19.41 10.31a5.69 5.69 0 00.07.71c.65-5.31 9.07-9.59 19.34-9.59z"
                    fill="#c74848"
                  />
                  <path
                    d="M453.27 453.74l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.87-.42-3.45 2-1.15 4.09.59 5.82l-3.46 2c-.51-.58-.4-1.16.42-1.73l-4-2.32c-2.74 1.71-2.1 3.87.64 5.77l-1.8 1.05 1.41.8 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.4-2 1-4.08-.7-5.83l3.4-2c.41.48.32 1-.4 1.55l4.05 2.33c2.55-1.73 2.16-3.75-.64-5.64zm-9.81 7.37a3.46 3.46 0 01-3 .07l3.1-1.8c.55.68.68 1.27-.1 1.73zm2.44-4.71c-.45-.67-.51-1.24.25-1.68a3.1 3.1 0 012.8-.1z"
                    fill="#c74848"
                  />
                  <path
                    d="M453.27 453.1l1.77-1-1.4-.81-1.78 1c-3.2-1.62-7.14-2-9.87-.42-3.45 2-1.15 4.09.59 5.82l-3.46 2c-.51-.58-.4-1.15.42-1.72l-4-2.33c-2.74 1.71-2.1 3.88.64 5.77l-1.8 1 1.41.81 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.4-2 1-4.09-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4.05 2.33c2.55-1.68 2.16-3.68-.64-5.58zm-9.81 7.36a3.46 3.46 0 01-3 .08l3.1-1.81c.55.69.68 1.27-.1 1.73zm2.44-4.71c-.45-.67-.51-1.24.25-1.68A3.1 3.1 0 01449 454z"
                    fill="#8f0a0a"
                  />
                </g>
                <g>
                  <path
                    d="M469.89 449.71v5.6c0 7.57-11.28 13.7-25.2 13.7s-25.21-6.13-25.21-13.7v-5.6z"
                    fill="#c74848"
                  />
                  <path
                    d="M457.5 467.07c-.81.27-1.63.52-2.5.74V453.7h2.5zm-25.59.05c.8.27 1.63.53 2.5.74v-14.1h-2.5zm32.18-3.07a14.57 14.57 0 004.39-4.26v-9.44h-4.39z"
                    style={{
                      mixBlendMode: "screen",
                    }}
                    fill="#de0000"
                    opacity={0.41}
                  />
                  <path
                    d="M419.48 449.71c0 7.57 11.28 13.7 25.21 13.7s25.2-6.13 25.2-13.7S458.61 436 444.69 436s-25.21 6.14-25.21 13.71z"
                    fill="#8f0a0a"
                  />
                  <path
                    d="M425.28 449.53c0 5.69 8.69 10.31 19.41 10.31s19.4-4.62 19.4-10.31-8.69-10.3-19.4-10.3-19.41 4.62-19.41 10.3z"
                    fill="#d43131"
                  />
                  <path
                    d="M444.69 440.66c10.26 0 18.64 4.24 19.33 9.59a5.66 5.66 0 00.07-.72c0-5.68-8.69-10.3-19.4-10.3s-19.41 4.62-19.41 10.3a5.66 5.66 0 00.07.72c.65-5.35 9.07-9.59 19.34-9.59z"
                    fill="#c74848"
                  />
                  <path
                    d="M453.27 445.36l1.77-1-1.4-.81-1.78 1c-3.2-1.63-7.14-2-9.87-.43-3.45 2-1.15 4.1.59 5.82l-3.46 2c-.51-.58-.4-1.16.42-1.73l-4-2.32c-2.74 1.71-2.1 3.87.64 5.77l-1.8 1 1.41.81 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.4-2 1-4.08-.7-5.83l3.4-2c.41.48.32 1-.4 1.54l4.05 2.34c2.55-1.68 2.16-3.7-.64-5.59zm-9.81 7.37a3.46 3.46 0 01-3 .07l3.1-1.8c.55.68.68 1.27-.1 1.73zm2.44-4.73c-.45-.67-.51-1.24.25-1.68a3.1 3.1 0 012.8-.1z"
                    fill="#c74848"
                  />
                  <path
                    d="M453.27 444.72l1.77-1-1.4-.81-1.78 1c-3.2-1.62-7.14-2-9.87-.42-3.45 2-1.15 4.09.59 5.82l-3.46 2c-.51-.58-.4-1.16.42-1.72l-4-2.33c-2.74 1.71-2.1 3.88.64 5.77l-1.8 1.05 1.41.81 1.77-1c3.65 1.92 7.63 1.81 10 .43 3.4-2 1-4.09-.7-5.84l3.4-2c.41.48.32 1-.4 1.54l4.05 2.33c2.55-1.73 2.16-3.74-.64-5.63zm-9.81 7.36a3.46 3.46 0 01-3 .07l3.1-1.8c.55.65.68 1.28-.1 1.73zm2.44-4.71c-.45-.67-.51-1.24.25-1.68a3.1 3.1 0 012.8-.09z"
                    fill="#8f0a0a"
                  />
                </g>
              </g>
              <g id="prefix__person3">
                <path
                  d="M463.4 341.36c-.56 3.37-1.72 8.8-2.27 12.17a12.77 12.77 0 00-.25 3.59 4.4 4.4 0 001.64 3.11c1.27.9 3 .79 4.53.63l7-.71a12.85 12.85 0 003.53-.69 4.35 4.35 0 002.54-2.41c.5-1.41 0-2.95-.56-4.35q-1.4-3.69-2.78-7.38a34.49 34.49 0 00-1.42-3.38"
                  fill="#3d00bd"
                />
                <path
                  fill="#130159"
                  d="M507.32 453.88l-.32 7.37 14.48 6.28-7.03-10.94-1.87-4.3-5.26 1.59zM518.21 449.1l-.33 7.37 15.78 1.82-8.32-6.48-1.88-4.3-5.25 1.59z"
                />
                <path
                  d="M472 390.21c-2.52 10.55 3.13 12.9 9.6 15.23 6.94 2.5 20.8 4.56 20.8 4.56l14.88 40.48c2.57 1.83 5.29 1.19 8.11-1.18l-12.6-46.17-24.9-13.91z"
                  fill="#5601f3"
                />
                <path
                  d="M465.33 395.33c-2.52 10.54 3.13 12.89 9.6 15.23 6.93 2.5 20.79 4.56 20.79 4.56L506 454.8c2.15 2 5.07 1.66 8.47 0l-9.86-46-22.46-14.46z"
                  fill="#681ef7"
                />
                <path
                  d="M490 390.42c-.42-2.82-6.06-2.13-5.52-14.46.35-8-.95-18.23-5.42-20.6-3.76-2-11.38 1.51-13.41 2.8-4.31 2.75-2.13 4.38-3.05 9.41S462 395 462 400.1c0 1.95 17.56 5.91 27-6.31"
                  fill="#f70083"
                />
                <path
                  d="M488.87 407.91c-1.19-.69-11.17-6.49-13.23-7.7a.25.25 0 010-.43l24.25-14.1a.3.3 0 01.26 0l13.21 7.69a.25.25 0 010 .44l-24.25 14.1a.25.25 0 01-.24 0z"
                  fill="#827fde"
                />
                <path
                  d="M513.27 393.42l-24.12 14a.31.31 0 01-.32 0l-13.09-7.61a.33.33 0 010-.56l24.13-14a.36.36 0 01.32 0l13.08 7.62a.31.31 0 010 .55z"
                  fill="#dfe3ff"
                />
                <path
                  d="M497.08 387.3c2.2.48 6.25 3.2 5.84 4s-2.55 2.71-7.56-2 1.72-2 1.72-2z"
                  fill="#fed4bd"
                />
                <path
                  d="M487.37 387.27l8 3.68c.2-1.88 2.14-2.79 4.25-2.8l-13.23-8.85-1.83-6.61s-.07 4.59 0 6.37c.08 3.48.96 6.55 2.81 8.21z"
                  fill="#f1539a"
                />
                <path
                  d="M469.65 357.4c-.11 1.74 5 .69 4.3-.68-.34-1.85-.67-3.71-1-5.56a4.12 4.12 0 00-.61-1.75c-1.41-1.88-2.48-.44-2.56 1.08-.13 2.29-.09 4.61-.13 6.91z"
                  fill="#fed4bd"
                />
                <path
                  d="M476.1 346.33a8.62 8.62 0 000-5.84 5.22 5.22 0 00-4.49-3.39 5.45 5.45 0 00-4.84 3.5 10.53 10.53 0 00-.25 6.24 8.21 8.21 0 002.37 4.63c4.01 3.39 6.18-2.05 7.21-5.14z"
                  fill="#fed4bd"
                />
                <path
                  d="M471.38 343.88a1.64 1.64 0 001.27 1.53 2.13 2.13 0 013.63.14 2.39 2.39 0 001.63-1.62 4.79 4.79 0 000-2.38 10.22 10.22 0 00-.7-2.24 7.29 7.29 0 00-1.36-2.1c-1.39-1.48-5.51-2.43-7.52-.68-4.11-.53-5.07 3.33-5.12 6.68-.28 1.86 1.07 3.26 1.65 5.05a1.79 1.79 0 002.17 1.2c.88-.13-1.46-2-1-4.29.25-1.2 1.45 1.48 1.86 1.34a26.75 26.75 0 01.41-2.78c.89.61 2.25 1.58 3.08.15z"
                  fill="#3d00bd"
                />
                <path
                  d="M481.83 395.73c2.2.47 6.25 3.19 5.84 4s-2.55 2.71-7.56-2 1.72-2 1.72-2z"
                  fill="#fed4bd"
                />
                <path
                  d="M464.8 359c-6.25 1-5.36 24.44-3.16 29.11s18.41 10.68 18.41 10.68c.61-2.14 1.69-3.26 3.18-3.5L467.78 384s0-10.25.08-13.93c.08-2.54 2.25-11.99-3.06-11.07z"
                  fill="#f1539a"
                />
                <g>
                  <path
                    d="M488.65 407c.91-3.08 3.8-12.81 4.32-14.54a.69.69 0 01.32-.41L517 378.29a.39.39 0 01.57.45l-4.32 14.53a.73.73 0 01-.32.41l-23.67 13.76a.39.39 0 01-.61-.44z"
                    fill="#8285df"
                  />
                  <path
                    d="M489.27 407.27c.91-3.08 3.8-12.81 4.31-14.54a.71.71 0 01.33-.41l23.67-13.76a.39.39 0 01.57.45l-4.32 14.54a.71.71 0 01-.33.41l-23.66 13.75a.39.39 0 01-.57-.44z"
                    fill="#d9dff6"
                  />
                </g>
              </g>
            </motion.g>
            <g id="prefix__notebook">
              <path
                d="M204.09 371.45a8.82 8.82 0 018 0l154.76 89.94c2.2 1.28 2.18 3.35 0 4.63L251 532a8.81 8.81 0 01-8 0L88.22 442.11c-2.19-1.28-2.18-3.35 0-4.64z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#e6e6e6"
                opacity={0.5}
              />
              <path
                d="M204.48 369.62a8.64 8.64 0 017.86 0L364.5 458c2.16 1.25 2.15 3.29 0 4.55l-113.92 64.96a8.64 8.64 0 01-7.86 0L90.57 439.09c-2.16-1.26-2.15-3.29 0-4.55z"
                fill="#571313"
              />
              <path
                d="M206.12 375.25a8.08 8.08 0 017.31 0l141.3 82.12c2 1.17 2 3.06 0 4.23l-105.79 60.28a8 8 0 01-7.3 0l-141.31-82.11c-2-1.17-2-3.06 0-4.23z"
                fill="#fff"
              />
              <path
                d="M185.43 374.57a6.19 6.19 0 015.62 0l5.91 3.62c1.55.9 1.54 2.36 0 3.26l-81.5 46.45a6.21 6.21 0 01-5.63 0l-5.91-3.62c-1.55-.9-1.54-2.36 0-3.26z"
                fill="#820d0d"
              />
              <motion.path

                animate={{opacity:[0,1,0]}}
                transition={{duration:5, loop:Infinity}}
                d="M233.22 505.34a1.74 1.74 0 01-1.5-.85 1.69 1.69 0 01.63-2.33L324 450a1.74 1.74 0 012.36.63 1.69 1.69 0 01-.64 2.32l-91.64 52.14a1.79 1.79 0 01-.86.25zm-12.88-7.83a1.73 1.73 0 01-1.49-.86 1.68 1.68 0 01.63-2.32l91.64-52.14a1.74 1.74 0 012.36.63 1.69 1.69 0 01-.63 2.32l-91.64 52.14a1.86 1.86 0 01-.87.23zm-12.87-7.83a1.73 1.73 0 01-1.5-.86 1.67 1.67 0 01.63-2.32l91.64-52.14a1.74 1.74 0 012.36.62 1.69 1.69 0 01-.63 2.33l-91.64 52.14a1.82 1.82 0 01-.86.23zm-12.88-7.84a1.72 1.72 0 01-1.5-.85 1.7 1.7 0 01.63-2.33l91.65-52.13a1.75 1.75 0 012.36.62 1.7 1.7 0 01-.64 2.33l-91.64 52.14a1.78 1.78 0 01-.86.22zM181.71 474a1.72 1.72 0 01-1.5-.85 1.7 1.7 0 01.64-2.33l91.64-52.13a1.74 1.74 0 012.36.62 1.69 1.69 0 01-.63 2.33l-91.65 52.14a1.78 1.78 0 01-.86.22zm-12.88-7.83a1.72 1.72 0 01-1.49-.85A1.69 1.69 0 01168 463l91.64-52.13a1.74 1.74 0 012.36.62 1.69 1.69 0 01-.63 2.33L169.7 466a1.81 1.81 0 01-.87.18zM156 458.35a1.74 1.74 0 01-1.5-.85 1.69 1.69 0 01.63-2.33L246.74 403a1.71 1.71 0 012.35.62 1.69 1.69 0 01-.63 2.33l-91.64 52.13a1.68 1.68 0 01-.82.27zm-12.88-7.83a1.74 1.74 0 01-1.5-.85 1.69 1.69 0 01.63-2.33l91.65-52.14a1.75 1.75 0 012.36.63 1.7 1.7 0 01-.63 2.33l-91.65 52.13a1.68 1.68 0 01-.9.23zm-12.88-7.83a1.74 1.74 0 01-1.49-.85 1.69 1.69 0 01.63-2.33L221 387.37a1.74 1.74 0 012.36.63 1.7 1.7 0 01-.63 2.33l-91.64 52.13a1.72 1.72 0 01-.89.23z"
                fill="#ff5e5e"
              />
            </g>
            <g id="prefix__calculator">
              <path
                d="M354.61 582.58l-60.6-35a4.42 4.42 0 010-7.66l89-51.38a16 16 0 0116.05 0l54.83 31.65a7.79 7.79 0 010 13.48l-84.71 48.9a14.56 14.56 0 01-14.57.01z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#bbb8f6"
                opacity={0.5}
              />
              <path
                d="M455.35 518.2l-3.72.55-61.1-35.28-91.12 52.6v-1l-5.16-.17v5.2a6.18 6.18 0 003.1 5.36l57.51 33.3a15 15 0 0014.93 0L452 531.48a6.79 6.79 0 003.39-5.87z"
                fill="#333"
              />
              <path
                d="M355.37 572.7l-59.08-34.11a4.08 4.08 0 010-7.07l86.57-50a15.34 15.34 0 0115.34 0l53.49 30.88a7.33 7.33 0 010 12.69l-82.42 47.61a13.91 13.91 0 01-13.9 0z"
                fill="#c41b1b"
              />
              <path
                d="M444.76 514.78l-47.44-27.39a15.49 15.49 0 00-15.5 0 5.15 5.15 0 000 8.92l47.43 27.38a15.51 15.51 0 0015.51 0 5.14 5.14 0 000-8.91zM361.47 513.51l-10.14-5.86a1.6 1.6 0 010-2.76l10.14-5.89a1.56 1.56 0 011.59 0l10.14 5.85a1.6 1.6 0 010 2.76l-10.14 5.86a1.61 1.61 0 01-1.59.04zM378 523.06l-10.14-5.85a1.6 1.6 0 010-2.76L378 508.6a1.56 1.56 0 011.59 0l10.14 5.85a1.6 1.6 0 010 2.76l-10.14 5.85a1.56 1.56 0 01-1.59 0zM394.58 532.62l-10.14-5.85a1.6 1.6 0 010-2.76l10.14-5.85a1.58 1.58 0 011.6 0l10.13 5.84a1.59 1.59 0 010 2.76l-10.13 5.85a1.58 1.58 0 01-1.6.01z"
                fill="#333"
              />
              <path
                d="M411.14 542.18L401 536.33a1.6 1.6 0 010-2.76l10.14-5.86a1.61 1.61 0 011.59 0l10.14 5.86a1.6 1.6 0 010 2.76l-10.14 5.85a1.56 1.56 0 01-1.59 0z"
                fill="#eaeeee"
              />
              <path
                d="M344.74 523.16l-10.13-5.85a1.59 1.59 0 010-2.76l10.13-5.85a1.58 1.58 0 011.6 0l10.14 5.85a1.6 1.6 0 010 2.76l-10.14 5.85a1.58 1.58 0 01-1.6 0zM361.3 532.72l-10.14-5.85a1.6 1.6 0 010-2.76l10.14-5.86a1.61 1.61 0 011.59 0l10.11 5.86a1.6 1.6 0 010 2.76l-10.14 5.85a1.56 1.56 0 01-1.56 0zM377.86 542.28l-10.14-5.85a1.6 1.6 0 010-2.76l10.14-5.86a1.61 1.61 0 011.59 0l10.14 5.86a1.6 1.6 0 010 2.76l-10.14 5.85a1.56 1.56 0 01-1.59 0z"
                fill="#d9dff6"
              />
              <path
                d="M394.41 551.84L384.27 546a1.6 1.6 0 010-2.77l10.14-5.85a1.63 1.63 0 011.6 0l10.13 5.85a1.6 1.6 0 010 2.77L396 551.84a1.63 1.63 0 01-1.59 0z"
                fill="#333"
              />
              <path
                d="M328 532.82L317.88 527a1.6 1.6 0 010-2.77l10.12-5.88a1.61 1.61 0 011.59 0l10.14 5.85a1.6 1.6 0 010 2.77l-10.14 5.85a1.61 1.61 0 01-1.59 0zM344.57 542.38l-10.13-5.85a1.6 1.6 0 010-2.77l10.13-5.85a1.63 1.63 0 011.6 0l10.14 5.85a1.6 1.6 0 010 2.77l-10.14 5.85a1.63 1.63 0 01-1.6 0zM361.13 551.94L351 546.08a1.6 1.6 0 010-2.76l10.14-5.85a1.56 1.56 0 011.59 0l10.14 5.85a1.59 1.59 0 010 2.76l-10.13 5.86a1.63 1.63 0 01-1.61 0z"
                fill="#d9dff6"
              />
              <path
                d="M359.81 570.49l-8.68-5a1.8 1.8 0 010-3.12l25.41-14.67a3.91 3.91 0 013.89 0l8.68 5a1.8 1.8 0 010 3.12l-25.41 14.67a3.91 3.91 0 01-3.89 0z"
                fill="#eaeeee"
              />
              <path
                d="M311.29 542.48l-10.13-5.86a1.59 1.59 0 010-2.76l10.13-5.86a1.58 1.58 0 011.6 0l10.11 5.86a1.59 1.59 0 010 2.76l-10.13 5.86a1.63 1.63 0 01-1.58 0zM327.85 552l-10.14-5.85a1.6 1.6 0 010-2.76l10.14-5.85a1.56 1.56 0 011.59 0l10.14 5.85a1.6 1.6 0 010 2.76L329.44 552a1.56 1.56 0 01-1.59 0zM344.4 561.59l-10.13-5.85a1.59 1.59 0 010-2.76l10.13-5.85a1.58 1.58 0 011.6 0l10.14 5.87a1.6 1.6 0 010 2.76L346 561.59a1.58 1.58 0 01-1.6 0z"
                fill="#d9dff6"
              />
            </g>
            <g id="prefix__pen1">
              <path
                d="M77.55 466a6.54 6.54 0 016.53 0l101.4 59a6.56 6.56 0 010 11.38 6.58 6.58 0 01-6.54 0L77.49 477.4a6.57 6.57 0 01.06-11.4z"
                style={{
                  mixBlendMode: "multiply",
                }}
                fill="#e6e6e6"
                opacity={0.5}
              />
              <path
                d="M173.22 513.28a4.13 4.13 0 01.87-.19h.08a3 3 0 01.85 0 2.23 2.23 0 01.77.29l-90.34-52.59-.27-.13-.28-.1-.19-.05H83.5a3.94 3.94 0 00-.47.1l-.2.07-.19.06-.24.08c-.24.11-.49.23-.74.37a9.26 9.26 0 00-1 .69l-.31.27a6.1 6.1 0 00-.46.41l-.21.22a1.54 1.54 0 00-.17.19 2 2 0 00-.2.21c-.15.17-.29.34-.43.52l-.15.2-.07.1-.14.18-.31.46-.27.45-.21.37c-.08.15-.16.3-.23.46s-.13.27-.19.4v.06c-.07.16-.14.31-.2.47l-.18.51a2.17 2.17 0 00-.07.24v.3c0 .07-.11.4-.15.6s0 .25-.06.37a1.06 1.06 0 000 .19v.18a9.06 9.06 0 00-.07 1 3.74 3.74 0 001.56 3.41l90.39 52.63a3.72 3.72 0 01-1.56-3.41 8.34 8.34 0 01.1-1.21v-.19c.07-.39.16-.77.27-1.16v-.11a11.82 11.82 0 01.47-1.25 11.8 11.8 0 01.62-1.23 12.1 12.1 0 01.73-1.13l.08-.1a10 10 0 01.77-.93l.18-.19a7.81 7.81 0 01.67-.62l.3-.28a8.83 8.83 0 011-.68 5.74 5.74 0 011-.46z"
                fill="#571313"
              />
              <path
                d="M76.44 469.29v-.18a1.06 1.06 0 010-.19c0-.12 0-.24.06-.37s.09-.4.15-.6 0-.13 0-.19v-.11a2.17 2.17 0 01.07-.24l.18-.51c.06-.16.13-.31.2-.47v-.06c.06-.13.12-.27.19-.4s.15-.31.23-.46l.21-.37.27-.45.31-.46.14-.18.07-.1.15-.2c.14-.18.28-.35.43-.52a2 2 0 01.2-.21 1.54 1.54 0 01.17-.19l.21-.22a6.1 6.1 0 01.46-.41l.31-.27a9.26 9.26 0 011-.69c.25-.14.5-.26.74-.37l.24-.08.19-.06.2-.07a3.94 3.94 0 01.47-.1H84.47l.19.05.28.1.27.13 4.81 2.81h-.24a3.22 3.22 0 00-.5.11l-.21.07-.2.07-.26.09c-.26.11-.52.24-.8.39a11.93 11.93 0 00-1.06.74l-.33.29c-.17.15-.34.28-.5.44s-.14.16-.22.23l-.18.2-.22.23c-.16.18-.31.37-.46.56l-.15.21-.08.11-.15.2-.33.49c-.1.16-.2.32-.29.49-.08.13-.15.26-.22.4s-.17.32-.25.48l-.2.44c-.07.17-.14.34-.2.51s-.14.36-.2.54 0 .17-.08.26v.12a1.17 1.17 0 00-.06.2c-.06.21-.12.43-.16.65s0 .26-.07.39 0 .13 0 .2v.19a8.48 8.48 0 00-.07 1.11 5.35 5.35 0 00.45 2.28l-4.7-2.74a3.74 3.74 0 01-1.56-3.41 9.06 9.06 0 01-.08-.9z"
                fill="#f79696"
              />
              <path
                d="M172.05 513.8a3.78 3.78 0 013.76-.39c1 .55 12.94 17.83 12.94 17.83s-19.46-4.32-20.42-4.87a3.73 3.73 0 01-1.57-3.42 11.66 11.66 0 015.29-9.15z"
                fill="#fff"
              />
              <path
                d="M183.85 524.24c2.64 3.74 4.9 7 4.9 7s-3.53-.78-7.65-1.72c-1.65-2.45 1.37-5.85 2.75-5.28z"
                fill="#f79696"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;

